import axios from '../axios'

// 全コース横断のクイズ一覧（admin・クイズ管理）
const getAllQuizzesApi = async () => {
  return await axios.get('api/lms/quizzes')
}

export default getAllQuizzesApi
